import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = {
  id: "app-router"
};
import { onMounted } from "vue";
import "@/kefu/customer-service.js";
export default {
  __name: 'App',
  setup(__props) {
    onMounted(() => {
      showCustomerService();
    });
    function showCustomerService() {
      // 等待DOM加载完成
      if (document.readyState === "loading") {
        document.addEventListener("DOMContentLoaded", function () {
          window.showCustomerService();
        });
      } else {
        // DOM已经加载完成
        window.showCustomerService();
      }
    }
    return (_ctx, _cache) => {
      const _component_RouterView = _resolveComponent("RouterView");
      return _openBlock(), _createElementBlock("div", _hoisted_1, [_createVNode(_component_RouterView)]);
    };
  }
};